import React, { useState } from 'react'
import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useStyles as useEditFormStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const useStyles = makeStyles(theme => ({
  optionsColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  optionLabel: {
    alignItems: 'flex-start',
    margin: 0,
    '& .MuiFormControlLabel-label': {
      marginTop: 2,
      marginLeft: theme.spacing(0.5),
      paddingTop: theme.spacing(0.25),
      width: '100%',
    },
  },
  optionTitle: {
    fontSize: '1rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.25,
  },
  optionDescription: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    marginTop: theme.spacing(1),
  },
  radio: {
    padding: theme.spacing(1),
    marginTop: -2,
    color: '#70787C',
    '&.Mui-checked': {
      color: '#0053FF',
    },
  },
}))

const ACCESS_OPTIONS = [
  {
    value: 'open',
    title: 'Open registration',
    description: 'Anyone will be able to register for this offering.',
  },
  {
    value: 'code',
    title: 'Require access code',
    description:
      'Create your own code and share with contacts to allow them to register.',
  },
]

const BookingTypeAccessCode = ({
  classes: legacyClasses,
  register,
  errors,
  setValue,
  bookingType,
  isEditFlow = false,
}) => {
  const accessCode = bookingType?.accessCode
  const [showAccessCodeInput, setShowAccessCodeInput] = useState(!!accessCode)
  const classes = useStyles()
  const editClasses = useEditFormStyles()

  const handleAccessChange = event => {
    const requiresCode = event.target.value === 'code'
    if (!requiresCode) {
      setValue('accessCode', '', { shouldDirty: true })
    }
    setShowAccessCodeInput(requiresCode)
  }

  if (isEditFlow) {
    return (
      <Box className={editClasses.fieldGroup}>
        <Typography
          className={editClasses.sectionHeading}
          style={{ marginBottom: 12 }}
        >
          Access Code
        </Typography>
        <RadioGroup
          className={classes.optionsColumn}
          value={showAccessCodeInput ? 'code' : 'open'}
          onChange={handleAccessChange}
        >
          {ACCESS_OPTIONS.map(option => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              className={classes.optionLabel}
              control={<Radio className={classes.radio} color="primary" />}
              label={
                <Box width="100%">
                  <Typography className={classes.optionTitle}>
                    {option.title}
                  </Typography>
                  <Typography className={classes.optionDescription}>
                    {option.description}
                  </Typography>
                  {option.value === 'code' && showAccessCodeInput ? (
                    <TextField
                      className={editClasses.fieldInput}
                      name="accessCode"
                      inputRef={register}
                      error={!!errors.accessCode}
                      helperText={
                        errors.accessCode && errors.accessCode.message
                      }
                      label="Access Code"
                      variant="outlined"
                      fullWidth
                      style={{ marginTop: 16 }}
                    />
                  ) : null}
                </Box>
              }
            />
          ))}
        </RadioGroup>
      </Box>
    )
  }

  return (
    <Box mt={3} mb={4}>
      <Typography variant="subtitle1" gutterBottom>
        Access Code
      </Typography>
      <FormControl>
        <RadioGroup aria-labelledby="Access Code">
          <FormControlLabel
            checked={!showAccessCodeInput}
            control={<Radio color="primary" />}
            label="Open Registration"
            onClick={() => {
              setValue('accessCode', '', { shouldDirty: true })
              setShowAccessCodeInput(false)
            }}
          />
          <Typography
            variant="body2"
            gutterBottom
            style={{ marginLeft: '32px' }}
          >
            Anyone will be able to register for this offering.
          </Typography>
          <FormControlLabel
            checked={showAccessCodeInput}
            control={<Radio color="primary" />}
            label="Require Access Code"
            onClick={() => {
              setShowAccessCodeInput(true)
            }}
          />
          <Typography
            variant="body2"
            gutterBottom
            style={{ marginLeft: '32px' }}
          >
            Requiring an access code is a way to password protect your offering.
            Create your own code and share with contacts to allow them to
            register.
            <TextField
              style={{ display: showAccessCodeInput ? 'block' : 'none' }}
              className={legacyClasses.formField}
              name="accessCode"
              inputRef={register}
              error={!!errors.accessCode}
              helperText={errors.accessCode && errors.accessCode.message}
              label="Create access code"
            />
          </Typography>
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default BookingTypeAccessCode
